import { Image } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import ru from 'assets/img/lang/ru.svg';
import en from 'assets/img/lang/en.svg';
import StorageKeys from 'constants/StorageKeys';

const LangSwitcher: FC = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language.split('-')[0];
  const nextLang = currentLang === 'ru' ? 'en' : 'ru';

  return (
    <button
      type="button"
      aria-label={t('selectAppLanguage') ?? ''}
      title={t(nextLang === 'ru' ? 'russianLang' : 'englishLang') ?? ''}
      onClick={() => {
        void i18n.changeLanguage(nextLang);
        localStorage.setItem(StorageKeys.lang, nextLang);
      }}
    >
      <Image w="20px" h="20px" src={currentLang === 'ru' ? ru : en} alt="" ml="0 !important" />
    </button>
  );
};

export default LangSwitcher;
